export default {
  components: {
    locationSelector: {
      labelKey: 'cmp-bus-directory-map-sub-title-key-location',
      inputItem: {
        placeholder: 'cmp-bus-directory-map-select-origin-city',
      },
    },
    list: {
      itemSettings: {
        open: true,
        showCallToAction: false,
        showHoursOperation: false,
        showTicketTypes: false,
        showSpecialInstructions: false,
        showTelephoneNumbers: false,
        showLocationType: false,
      },
    },
  },
  prePopulation: {
    locationSearchOptions: {
      outputCategory: ['CITIES', 'STATIONS'],
    },
    busSearchOptions: {
      geoField: {
        value: 50.0,
      },
      sortingDetails: [
        {
          field: 'geo',
          order: 'ASC',
        },
      ],
    },
    busSearchOptionsOnInteractive: {
      default: {
        geoField: false,
        sortingDetails: [
          {
            field: 'cityName',
            order: 'ASC',
          },
        ],
      },
    },
  },
};
